import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './profileevents.css';
import api from '../../api/axios';
import { MatchingEventsPopup } from "../../components";
import { useTranslation } from 'react-i18next';

const Profileevents = ({ bookedEvents }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [showPopup, setShowPopup] = useState(false);
    const [bookedEventsData, setBookedEventsData] = useState([]);

    const navigateEvents = (eventData) => {
        navigate('/profile/myevents', { state: { eventData } });
    };

    const handleAddEvent = () => {
        navigate('/eventsstore');
    };

    const handleMatchEventClick = () => {
        setShowPopup(true); // Open the popup
    };

    const closePopup = () => {
        setShowPopup(false); // Close the popup
    };

    // Get today's date and set the threshold to 2 days in the past
    const today = new Date();
    const pastThreshold = new Date();
    pastThreshold.setDate(today.getDate() - 2);

    bookedEvents.forEach(event => {
        const eventDate = new Date(event.date);
    });

    const formatEventDate = (dateString) => {
        const options = {
            timeZone: 'Europe/Berlin', // Change to your desired time zone
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        };
        const dateTimeFormat = new Intl.DateTimeFormat('de-DE', options);
        const formattedDate = dateTimeFormat.format(new Date(dateString));
        return formattedDate; // Format as DD.MM.YYYY
    };

    useEffect(() => {

        const fetchBookedEvents = async () => {
            try {
                const response = await api.post('/user/getbookedevents');
                setBookedEventsData(response.data);
            } catch (err) {
                console.error("Error fetching booked events:", err);
            }
        };

        fetchBookedEvents();
    }, []);

    // Filter events (assuming already sorted in the backend)
    const upcomingEvents = bookedEventsData
        .filter(event => new Date(event.date) >= pastThreshold) // Only show events within 2 days in the past or future
        .slice(0, 3); // Limit to the first 3 events

    return (
        <div className="profile-bottom">
            <h3 style={{ textAlign: 'center' }}>{t('ProfileYourEvents')}</h3>
            <div className="wrapper-personal-events">
                {upcomingEvents.map((event) => (
                    <div className="event-wrapper" key={event.eventid}>
                        <div className="event-circle"><img src={event.lokalpic} alt="Event" style={{ width: "200px" }} /></div>
                        <div className="event-name">
                            <span onClick={() => navigateEvents(event)}>{event.eventname}</span>
                        </div>
                        <div className="event-name">
                            <span onClick={() => navigateEvents(event)}>{formatEventDate(event.date)}</span>
                        </div>
                    </div>
                ))}
                <div className="event-buttons-column">
                    <div className="event-wrapper" id="add-event-wrapper">
                        <button className="circle-button" onClick={handleAddEvent}>+</button>
                        <p><strong>{t('ProfileEventsAddEvent')}</strong></p>
                    </div>
                </div>
            </div>
            <div className="show-more-bottom-wrapper">
                <button className="show-more" onClick={() => navigateEvents()}>{t('ProfileEventsShowAllEvents')}</button>
            </div>
        </div>
    );
};

export default Profileevents;